// extracted by mini-css-extract-plugin
module.exports = {"label":"_0fce717cdb--label--ROz9i","icon":"_0fce717cdb--icon--kcS5n"};